export function initTravelAccordion() {
  const triggers = document.querySelectorAll(".travel-accordian-trigger");
  triggers.forEach((trigger) => {
    const newTrigger = trigger.cloneNode(true);
    trigger.parentNode.replaceChild(newTrigger, trigger);
  });
  const freshTriggers = document.querySelectorAll(".travel-accordian-trigger");
  freshTriggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = trigger.getAttribute("data-target");
      const content = document.getElementById(targetId);
      if (!content) return;
      const icon = trigger.querySelector(".acc-icon");
      const isOpening = content.classList.contains("hidden");

      const openBg = trigger.dataset.openBg;
      const openText = trigger.dataset.openText;
      const openBorder = trigger.dataset.openBorder;

      const closedBg = trigger.dataset.closedBg;
      const closedText = trigger.dataset.closedText;
      const closedBorder = trigger.dataset.closedBorder;

      if (isOpening) {
        if (closedBg) trigger.classList.remove(closedBg);
        if (closedText) trigger.classList.remove(closedText);
        if (closedBorder) trigger.classList.remove("border", closedBorder);
        if (openBg) trigger.classList.add(openBg);
        if (openText) trigger.classList.add(openText);
        if (openBorder) {
          openBorder.split(" ").forEach((cls) => {
            if (cls) trigger.classList.add(cls);
          });
        }
        if (icon && icon.dataset.openSrc) {
          icon.src = icon.dataset.openSrc;
        }
        content.classList.remove("hidden");
      } else {
        if (openBg) trigger.classList.remove(openBg);
        if (openText) trigger.classList.remove(openText);
        if (openBorder) {
          openBorder.split(" ").forEach((cls) => {
            if (cls) trigger.classList.remove(cls);
          });
        }
        if (closedBg) trigger.classList.add(closedBg);
        if (closedText) trigger.classList.add(closedText);
        if (closedBorder) {
          trigger.classList.add("border", closedBorder);
        }
        if (icon && icon.dataset.closedSrc) {
          icon.src = icon.dataset.closedSrc;
        }
        content.classList.add("hidden");
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initTravelAccordion();
});
